/* unplugin-vue-components disabled */import { render } from "./chats.vue?vue&type=template&id=067c92d3&scoped=true"
import script from "./chats.vue?vue&type=script&setup=true&lang=js"
export * from "./chats.vue?vue&type=script&setup=true&lang=js"

import "./chats.vue?vue&type=style&index=0&id=067c92d3&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067c92d3"],['__file',"src/pages/chats/chats.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "067c92d3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('067c92d3', __exports__)) {
    api.reload('067c92d3', __exports__)
  }
  
  module.hot.accept("./chats.vue?vue&type=template&id=067c92d3&scoped=true", () => {
    api.rerender('067c92d3', render)
  })

}


export default __exports__